import { Globe, RefreshCw } from "lucide-react";
import { inputCls } from "@agent/lib/styles";

export function BlogVersionSection({ draft, setDraft, blogGenerated, blogGenLoading, generateBlog, showBlog, setShowBlog }) {
  return (
    <div className="border border-slate-200 rounded-xl p-4 space-y-3 bg-slate-50/50">
      <div className="flex items-center justify-between">
        <p className="text-[11px] tracking-[0.2em] uppercase text-slate-400 font-semibold">Website blog version</p>
        {blogGenerated && (
          <button data-testid="toggle-blog-btn" onClick={() => setShowBlog(!showBlog)}
            className="text-xs font-medium text-indigo-600 hover:text-indigo-800 transition-colors duration-150">
            {showBlog ? "Hide" : "Show / edit"}
          </button>
        )}
      </div>
      {!blogGenerated && (
        <button data-testid="generate-blog-btn" onClick={generateBlog} disabled={blogGenLoading}
          className="w-full flex items-center justify-center gap-2 py-2.5 rounded-full bg-gradient-to-r from-indigo-500 to-violet-500 text-white text-xs font-semibold hover:opacity-90 transition-opacity duration-150 disabled:opacity-40">
          <Globe size={13} /> {blogGenLoading ? "Writing long-form article…" : "Generate blog version (enhanced article)"}
        </button>
      )}
      {blogGenerated && (
        <>
          <p className="text-xs text-slate-500">
            <span className="font-semibold text-[#0f172a]">"{draft.blog_title}"</span> · {draft.blog_markdown?.length || 0} chars markdown
            {draft.blog_tags?.length > 0 && <> · {draft.blog_tags.join(", ")}</>}
          </p>
          {draft.blog_url && (
            <a data-testid="blog-url-link" href={draft.blog_url} target="_blank" rel="noopener noreferrer"
              className="text-xs font-semibold text-emerald-600 hover:text-emerald-700 break-all">Live: {draft.blog_url}</a>
          )}
          {showBlog && (
            <div className="space-y-3 fade-up">
              <input data-testid="blog-title-input" className={inputCls} value={draft.blog_title || ""}
                onChange={(e) => setDraft({ ...draft, blog_title: e.target.value })} placeholder="Blog title" />
              <input data-testid="blog-tags-input" className={inputCls} value={(draft.blog_tags || []).join(", ")}
                onChange={(e) => setDraft({ ...draft, blog_tags: e.target.value.split(",").map((t) => t.trim()).filter(Boolean) })}
                placeholder="tags, comma-separated" />
              <textarea data-testid="blog-markdown-input" rows={12} value={draft.blog_markdown || ""}
                onChange={(e) => setDraft({ ...draft, blog_markdown: e.target.value })}
                className={`${inputCls} resize-y mono text-[13px] leading-relaxed`} placeholder="Markdown body…" />
              <button data-testid="regenerate-blog-btn" onClick={generateBlog} disabled={blogGenLoading}
                className="flex items-center gap-2 px-4 py-2 rounded-full border border-indigo-200 text-indigo-600 text-xs font-semibold hover:bg-indigo-50 transition-colors duration-150 disabled:opacity-40">
                <RefreshCw size={12} className={blogGenLoading ? "animate-spin" : ""} /> {blogGenLoading ? "Rewriting…" : "Regenerate blog"}
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}
